module.exports = __webpack_public_path__ + "fd5a608a/img/64000000-6.37ac333e.png";